<canvas #confettiCanvas id="confetti"></canvas>